module.exports = __webpack_public_path__ + "img/c02_unitvillager_Normal_ua.ee1d6790.webp";